export enum EUploadResolution {
    TINY = 100,
    SMALL = 200,
    PREVIEW = 400,
    MEDIUM = 600,
    LARGE = 1000,
    BIG = 1920,
    ULTRA = 4096
}
export function prepareImage(
    file: Blob,
    resolutions: EUploadResolution[],
    disableImageRefresh?: boolean,
    token?: string
): FormData {
    const formData = new FormData();
    formData.append('image', file);
    if (file.type) {
        formData.append('imageType', file.type);
    } else if (file.type === '' && file['name']?.toLowerCase().indexOf('.heic') >= 0) {
        formData.append('imageType', 'heic');
    } else if (file.type === '' && file['name']?.toLowerCase().indexOf('.heif') >= 0) {
        formData.append('imageType', 'heif');
    }
    if (disableImageRefresh) {
        formData.append('disableImageRefresh', 'true');
    }
    if (token) {
        formData.append('token', token);
    }
    formData.append('resolutions', JSON.stringify(resolutions));
    return formData;
}

export function prepareFile(file: Blob, fileType: 'gpx' | 'mp3'): FormData {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileType', fileType);
    return formData;
}

export function isWithinSize(bytes: number, limitMB: number): boolean {
    if (bytes / 1024000 >= limitMB) {
        return false;
    } else {
        return true;
    }
}
